import ElementUi from 'element-ui'
window.rootVue = window.rootVue
	? window.rootVue
	: {
			$gettext: (t) => {
				return t
			},
		}
const errorMsg = {
	RequestTimeout: {
		code: 'RequestTimeout',
		message: window.rootVue.$gettext('RequestTimeout'),
	},
	UnknowError: {
		code: 'UnknowError',
		message: window.rootVue.$gettext('unknow error'),
	},
	NeedLogin: {
		code: 'NeedLogin',
		message: window.rootVue.$gettext('Need login.'),
	},
	NeedPrivilege: {
		code: 'NeedPrivilege',
		message: window.rootVue.$gettext('Need privilege.'),
	},
	DomainInUse: {
		code: 'DomainInUse',
		message: window.rootVue.$gettext('Domain in use.'),
	},
	LoginFailed: {
		code: 'LoginFailed',
		message: window.rootVue.$gettext('Login failed.'),
	},
	VerifyFailed: {
		code: 'VerifyFailed',
		message: window.rootVue.$gettext('Verify failed.'),
	},
	AlreadySendSMS: {
		code: 'AlreadySendSMS',
		message: window.rootVue.$gettext('Already send SMS.'),
	},
	FileNotFound: {
		code: 'FileNotFound',
		message: window.rootVue.$gettext('File is not found.'),
	},
	QuickLinksNotFound: {
		code: 'QuickLinksNotFound',
		message: window.rootVue.$gettext('Quick links is not found.'),
	},
	ProjectResourceNotFound: {
		code: 'ProjectResourceNotFound',
		message: window.rootVue.$gettext('Workgroup Resource is not found.'),
	},
	LogFilterNotFound: {
		code: 'LogFilterNotFound',
		message: window.rootVue.$gettext('Log Filter is not found.'),
	},
	ProjectNotFound: {
		code: 'ProjectNotFound',
		message: window.rootVue.$gettext('Workgroup is not found.'),
	},
	NetworkNotFound: {
		code: 'NetworkNotFound',
		message: window.rootVue.$gettext('Cluster is not found.'),
	},
	PlanNotFound: {
		code: 'PlanNotFound',
		message: window.rootVue.$gettext('Plan is not found.'),
	},
	SkuNotFound: {
		code: 'SkuNotFound',
		message: window.rootVue.$gettext('Sku is not found.'),
	},
	BillNotFound: {
		code: 'BillNotFound',
		message: window.rootVue.$gettext('Bill is not found.'),
	},
	NoteNotFound: {
		code: 'NoteNotFound',
		message: window.rootVue.$gettext('Note is not found.'),
	},
	EndpointRequire: {
		code: 'EndpointRequire',
		message: window.rootVue.$gettext('You should have at least one endpoint in your resource pool.'),
	},
	InvalidParameter: {
		code: 'InvalidParameter',
		message: window.rootVue.$gettext('Parameter name is invalid.'),
	},
	BatchCreateFailed: {
		code: 'BatchCreateFailed',
		message: window.rootVue.$gettext('One or more parameters invalid in batch create.'),
	},
	BatchDeleteFailed: {
		code: 'BatchDeleteFailed',
		message: window.rootVue.$gettext('Error occured when batch delete.'),
	},
	LDAPError: {
		code: 'LDAPError',
		message: window.rootVue.$gettext('LDAP error, please contact your system administrator.'),
	},
	CompanyNotFound: {
		code: 'CompanyNotFound',
		message: window.rootVue.$gettext('Company is not found.'),
	},
	AccountNotFound: {
		code: 'AccountNotFound',
		message: window.rootVue.$gettext('Account is not found.'),
	},
	AccountExist: {
		code: 'AccountExist',
		message: window.rootVue.$gettext('Account is exist.'),
	},
	DeleteSelf: {
		code: 'DeleteSelf',
		message: window.rootVue.$gettext('You cannot delete yourself.'),
	},
	Locked: {
		code: 'Locked',
		message: window.rootVue.$gettext('Your account has been locked.'),
	},
	ResourceNotFound: {
		code: 'ResourceNotFound',
		message: window.rootVue.$gettext('Resource is not found.'),
	},
	TunnelIsOnline: {
		code: 'TunnelIsOnline',
		message: window.rootVue.$gettext('Tunnel is online.'),
	},
	TunnelNotFound: {
		code: 'TunnelNotFound',
		message: window.rootVue.$gettext('Tunnel is not found.'),
	},
	TunnelExpire: {
		code: 'TunnelExpire',
		message: window.rootVue.$gettext('Tunnel is expired.'),
	},
	NetworkExceeded: {
		code: 'NetworkExceeded',
		message: window.rootVue.$gettext('Cluster Exceeded.'),
	},
	NetworkHasResources: {
		code: 'NetworkHasResources',
		message: window.rootVue.$gettext('Cluster still has resources.'),
	},
	NetworkHasBeenShared: {
		code: 'NetworkHasBeenShared',
		message: window.rootVue.$gettext('Cluster has been shared.'),
	},
	AccountExceeded: {
		code: 'AccountExceeded',
		message: window.rootVue.$gettext('Account Exceeded.'),
	},
	ResourceExceeded: {
		code: 'ResourceExceeded',
		message: window.rootVue.$gettext('ResourceExceeded.'),
	},
	SubscriptionNotfound: {
		code: 'SubscriptionNotfound',
		message: window.rootVue.$gettext('Subscription is not found.'),
	},
	NetmaskTooSmall: {
		code: 'NetmaskTooSmall',
		message: window.rootVue.$gettext('NetmaskTooSmall'),
	},
	ResetLinkExpire: {
		code: 'ResetLinkExpire',
		message: window.rootVue.$gettext('Reset Link Has Expire'),
	},
	CaptchaIncorrect: {
		code: 'CaptchaIncorrect',
		message: window.rootVue.$gettext('Captcha Incorrect'),
	},
	VerificationCodeIncorrect: {
		code: 'VerificationCodeIncorrect',
		message: window.rootVue.$gettext('Verification Code Incorrect.'),
	},
	SubscribeForbidden: {
		code: 'SubscribeForbidden',
		message: window.rootVue.$gettext('Subscribe Forbidden'),
	},
	EmailSendFail: {
		code: 'EmailSendFail',
		message: window.rootVue.$gettext('Email send fail.'),
	},
	SMSSendFail: {
		code: 'SMSSendFail',
		message: window.rootVue.$gettext('SMS send fail.'),
	},
	ProjectNameExist: {
		code: 'ProjectNameExist',
		message: window.rootVue.$gettext('Workgroup Name is exist.'),
	},
	NetworkNameExist: {
		code: 'NetworkNameExist',
		message: window.rootVue.$gettext('Cluster Name is exist.'),
	},
	NetworkUnavailable: {
		code: 'NetworkUnavailable',
		message: window.rootVue.$gettext('Cluster unavailable.'),
	},
	ExpireTimeTooBig: {
		code: 'ExpireTimeTooBig',
		message: window.rootVue.$gettext('Expire Time Too Big.'),
	},
	SqlApplicationNotFound: {
		code: 'SqlApplicationNotFound',
		message: window.rootVue.$gettext('sql application not found.'),
	},
	RemovingSelf: {
		code: 'RemovingSelf',
		message: window.rootVue.$gettext('You cannot remove your self.'),
	},
	AgentAlreadyInstall: {
		code: 'AgentAlreadyInstall',
		message: window.rootVue.$gettext('there is already one have installed, please unbund the exist one on cloudlinker.'),
	},
	SharedNetworkCannotChangeLogFilter: {
		code: 'SharedNetworkCannotChangeLogFilter',
		message: window.rootVue.$gettext('Shared cluster cannot change log filter rules.'),
	},
	NetworkCannotShare: {
		code: 'NetworkCannotShare',
		message: window.rootVue.$gettext('Shared cluster cannot share to other company.'),
	},
	NetworkAlreadyShared: {
		code: 'NetworkAlreadyShared',
		message: window.rootVue.$gettext('Cluster already shared to the company or own is yourself.'),
	},
	MustBeLinuxServer: {
		code: 'MustBeLinuxServer',
		message: window.rootVue.$gettext('Must be Linux Server.'),
	},
	SetAutologinFailed: {
		code: 'SetAutologinFailed',
		message: window.rootVue.$gettext('Set auto login failed.'),
	},
	UpgradeSubscriptionFailed: {
		code: 'UpgradeSubscriptionFailed',
		message: window.rootVue.$gettext('Upgrade subscription failed.'),
	},
	CannotUpgradeSubscription: {
		code: 'CannotUpgradeSubscription',
		message: window.rootVue.$gettext('Cannot upgrade subscription.'),
	},
	SubscribeOvertime: {
		code: 'SubscribeOvertime',
		message: window.rootVue.$gettext('Subscribe overtime. The maximum length of subscription is 12.'),
	},
	SubscriptionFailed: {
		code: 'SubscriptionFailed',
		message: window.rootVue.$gettext('Subscription failed.'),
	},
	Timeout: {
		code: 'Timeout',
		message: window.rootVue.$gettext('Timeout.'),
	},
	TimeNotValid: {
		code: 'TimeNotValid',
		message: window.rootVue.$gettext('Need future time'),
	},
	HostsTypeError: {
		code: 'HostsTypeError',
		message: window.rootVue.$gettext('Hosts type error'),
	},
	NeedRenewOrUpdate: {
		code: 'NeedRenewOrUpdate',
		message: window.rootVue.$gettext('Need to renew or update'),
	},
	InvoiceTitleNeedCheck: {
		code: 'InvoiceTitleNeedCheck',
		message: window.rootVue.$gettext('Need to check invoice title'),
	},
	NeedInvoiceTitleAndAddress: {
		code: 'NeedInvoiceTitleAndAddress',
		message: window.rootVue.$gettext('Need invoice title and address'),
	},
	NeedInvoiceSubscriptions: {
		code: 'NeedInvoiceSubscriptions',
		message: window.rootVue.$gettext('Need invoice subscriptions'),
	},
	XiaoshouyiException: {
		code: 'XiaoshouyiException',
		message: window.rootVue.$gettext('Xiaoshouyi Error'),
	},
	CommandExist: {
		code: 'CommandExist',
		message: window.rootVue.$gettext('Command exist'),
	},
	NetworkSafeModeNotOpen: {
		code: 'NetworkSafeModeNotOpen',
		message: window.rootVue.$gettext('cluster safe_mode is not open'),
	},
	ApplicationExist: {
		code: 'ApplicationExist',
		message: window.rootVue.$gettext('cluster safe_mode application exist'),
	},
	NeedApplicationSafeMode: {
		code: 'NeedApplicationSafeMode',
		message: window.rootVue.$gettext('need apply safe mode'),
	},
	MfaCodeError: {
		code: 'MfaCodeError',
		message: window.rootVue.$gettext('need right mfa code'),
	},
	MfaKeyError: {
		code: 'MfaKeyError',
		message: window.rootVue.$gettext('need right mfa key'),
	},
	NeedMfaLogin: {
		code: 'NeedMfaLogin',
		message: window.rootVue.$gettext('need mfa login'),
	},
	AccountPubKeyNotFound: {
		code: 'AccountPubKeyNotFound',
		message: window.rootVue.$gettext('account pubkey not found'),
	},
	AccountPubKeyError: {
		code: 'AccountPubKeyError',
		message: window.rootVue.$gettext('account pubkey error'),
	},
	AccountPubKeyExist: {
		code: 'AccountPubKeyExist',
		message: window.rootVue.$gettext('account pubkey is exist'),
	},
	TunnelConnectionNotFound: {
		code: 'TunnelConnectionNotFound',
		message: window.rootVue.$gettext('Tunnel connection is not found.'),
	},
	RefreshTokenNotExists: {
		code: 'RefreshTokenNotExists',
		message: window.rootVue.$gettext('Refresh token is not exists.'),
	},
	InvalidToken: {
		code: 'InvalidToken',
		message: window.rootVue.$gettext('InvalidToken'),
	},
	AccountNotAllowDelete: {
		code: 'AccountNotAllowDelete',
		message: window.rootVue.$gettext("The account is bound to the primary account. Please change the bound administrator account in the team's Settings then delete it."),
	},
	ProjectAccountExist: {
		code: 'ProjectAccountExist',
		message: window.rootVue.$gettext('Workgroup Account Exist'),
	},
	AgentError: {
		code: 'AgentError',
		message: window.rootVue.$gettext('Agent is not online.'),
	},
	IncorrectInstanceStatus: {
		code: 'IncorrectInstanceStatus',
		message: window.rootVue.$gettext('The current status of the resource does not support this operation.'),
	},
	TooManyShadows: {
		code: 'TooManyShadows',
		message: window.rootVue.$gettext('Can not create more than 5 shadows'),
	},
	'InvalidInstanceId.NotFound': {
		code: 'InvalidInstanceId.NotFound',
		message: window.rootVue.$gettext('The specified InstanceId does not exist.'),
	},
	ConnectionIDNotFound: {
		code: 'ConnectionIDNotFound',
		message: window.rootVue.$gettext('Connection ID not found'),
	},
	TaskExpired: {
		code: 'TaskExpired',
		message: window.rootVue.$gettext('Task expired'),
	},
	AccountLocked: {
		code: 'AccountLocked',
		message: window.rootVue.$gettext('You have entered the wrong password 10 times. Please try again in 1 hour or change the password by find the password feature.'),
	},
	GroupExist: {
		code: 'GroupExist',
		message: window.rootVue.$gettext('Group Exist'),
	},
	GroupNameExist: {
		code: 'GroupNameExist',
		message: window.rootVue.$gettext('Group Name is exist'),
	},
	GroupNotFound: {
		code: 'GroupNotFound',
		message: window.rootVue.$gettext('Group not found'),
	},
	ProjectGroupExist: {
		code: 'ProjectGroupExist',
		message: window.rootVue.$gettext('Project Group Exist'),
	},
	ProjectGroupNotFound: {
		code: 'ProjectGroupNotFound',
		message: window.rootVue.$gettext('Project Group not found'),
	},
	GroupAccountExist: {
		code: 'GroupAccountExist',
		message: window.rootVue.$gettext('Group Account Exist'),
	},
	GroupAccountNotFound: {
		code: 'GroupAccountNotFound',
		message: window.rootVue.$gettext('Group Account not found'),
	},
	ResourceNameExist: {
		code: 'ResourceNameExist',
		message: window.rootVue.$gettext('Resource Name is exist'),
	},
	InvalidPassword: {
		code: 'InvalidPassword',
		message: window.rootVue.$gettext('Password complexity does not meet the requirements'),
	},
	PasswordError: {
		code: 'PasswordError',
		message: window.rootVue.$gettext('Password error'),
	},
	ProjectExist: {
		code: 'ProjectExist',
		message: window.rootVue.$gettext('Project Name is exist'),
	},
	InvalidResource: {
		code: 'InvalidResource',
		message: window.rootVue.$gettext('Invalid Resource Info'),
	},
	IPNotInWhiteList: {
		code: 'IPNotInWhiteList',
		message: window.rootVue.$gettext('IP is not in white list'),
	},
	AccountDisabled: {
		code: 'AccountDisabled',
		message: window.rootVue.$gettext('User disabled'),
	},
	AkError: {
		code: 'AkError',
		message: window.rootVue.$gettext('Please Confirm Whether Ak And Sk Are Correct'),
	},
	PermissionError: {
		code: 'PermissionError',
		message: window.rootVue.$gettext('Insufficient Data Access Rights. Please Grant IAM.ECS.ReadOnlyAccess'),
	},
	ParamError: {
		code: 'ParamError',
		message: window.rootVue.$gettext('Failed to obtain interface data. Please check if the parameters are correct!'),
	},
	InvalidStatisticTimeScope: {
		code: 'InvalidStatisticTimeScope',
		message: window.rootVue.$gettext('The Time Frame Cannot Exceed One Year. Please Adjust It And Try Again.'),
	},
}

const showErrorMsg = function (code, msg, type, options) {
	let error = errorMsg[code] || errorMsg[msg]
	let message = null
	if (error) {
		message = window.rootVue.$gettext(error.message)
		let keys = message.match(/#{[a-zA-Z0-9]+}/g)
		if (keys && keys.length && options) {
			keys.forEach((key) => {
				const _key = key.substring(2, key.length - 1)
				message = message.replace(new RegExp('#{' + _key + '}'), options[_key])
			})
		}
	}
	ElementUi.Notification({
		message: (code && errorMsg[code]) || errorMsg[msg] ? message : window.rootVue.$gettext ? window.rootVue.$gettext(msg) : msg,
		type: type || 'error',
	})
}

export default {
	showErrorMsg,
}



// WEBPACK FOOTER //
// ./src/api/errormsg.js